import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  nextId: 1,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // Add a new notification
    addNotification: (state, action) => {
      state.notifications.push({
        ...action.payload,
        id: state.nextId++,
        createdAt: Date.now(),
      });
    },
    // Remove a notification by ID
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload,
      );
    },
  },
});

export const {addNotification, removeNotification} = notificationsSlice.actions;

export default notificationsSlice.reducer;
